// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   Card,
//   Grid,
//   Divider,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   Container,
//   TableRow,
//   FormControlLabel,
//   Checkbox,
//   Radio
// } from '@mui/material';

// // Mapping between user types and plan features
// const userTypeMappings = {
//   buyer: {
//     label: 'Buyer',
//     features: ['no_of_properties']
//   },
//   tenant: {
//     label: 'Tenant',
//     features: ['no_of_properties']
//   },
//   seller: {
//     label: 'Seller/Builder',
//     features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
//   },
//   landlord: {
//     label: 'Landlord',
//   features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
//   },
//    agent: {
//     label: 'Agent',
//     features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
//   },
//   //  builder: {
//   //   label: 'Builder',
//   //  features: ['buyer_no', 'no_of_properties', 'no_of_liked_data', 'matching_enquiry']
//   // }
// };

// const SubscriptionForm = ({ 
//   selectedUserType, 
//   setSelectedUserType, 
//   selectedPlan, 
//   setSelectedPlan,
//   plans, 
//   handlePaymentSubmit 
// }) => {

//   const paymentRef = React.useRef(null);
  
//   const handleUserTypeChange = (userType) => {
//     setSelectedUserType(userType);
//     setSelectedPlan(null);
//   };

//  const handlePlanSelect = (plan) => {
//   setSelectedPlan(plan);
//   setTimeout(() => {
//     paymentRef.current?.scrollIntoView({ 
//       behavior: 'smooth',
//       block: 'nearest'
//     });
//   }, 100); // Small timeout ensures the DOM is updated
// };

//   // Get relevant plans for the selected user type
//   const getFilteredPlans = () => {
//     if (!selectedUserType) return [];
    
//     // Convert selectedUserType (e.g., "buyer") to the corresponding label (e.g., "Buyer")
//     const userTypeLabel = userTypeMappings[selectedUserType].label;
    
//     return plans
//        .filter(plan => plan.user_type === userTypeLabel && plan.status === true)
//       .map(plan => ({
//         ...plan,
//         displayName: `${plan.plan_name} ${userTypeLabel} Plan`
//       }));
//   };

//   return (
//     <Container
//       sx={{
//         py: 2,
//         flex: 1,
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 2,
//         maxWidth: 'sm'
//       }}
//     >
//       <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', mt: 0 }}>Choose Your Subscription</Typography>
      
//       {/* User Type Selection */}
//       <Card sx={{
//         borderRadius: '12px',
//         boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//         background: 'rgba(255, 255, 255, 0.8)',
//         p: 2
//       }}>
//         <Typography variant="h6" gutterBottom>I am a:</Typography>
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//           {Object.keys(userTypeMappings).map((userType) => (
//             <FormControlLabel
//               key={userType}
//               control={
//                 <Checkbox
//                   checked={selectedUserType === userType}
//                   onChange={() => handleUserTypeChange(userType)}
//                   color="primary"
//                   size="small"
//                 />
//               }
//               label={<Typography variant="body2">{userTypeMappings[userType].label}</Typography>}
//               sx={{ margin: 0 }}
//             />
//           ))}
//         </Box>
//       </Card>

//       {/* Plan Selection */}
//       {selectedUserType && (
//         <Card sx={{
//           borderRadius: '12px',
//           boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//           background: 'rgba(255, 255, 255, 0.8)',
//           p: 2
//         }}>
//           <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>
//             Available {userTypeMappings[selectedUserType].label} Plans:
//           </Typography>
//           <Grid 
//             container 
//             spacing={2} 
//             sx={{ 
//               justifyContent: 'center',
//               padding: '0 8px'
//             }}
//           >
//             {getFilteredPlans().map((plan) => (
//               <Grid 
//                 item 
//                 xs={12}
//                 key={plan.plan_id}
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'center'
//                 }}
//               >
//                 <Card 
//                   sx={{ 
//                     p: 2, 
//                     width: '100%',
//                     minWidth: '280px',
//                     maxWidth: '320px',
//                     border: selectedPlan?.plan_id === plan.plan_id ? '2px solid #1976d2' : '1px solid #ddd',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s ease',
//                     boxSizing: 'border-box',
//                     background: 'rgba(255, 255, 255, 0.9)',
//                     '&:hover': {
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 6px 24px rgba(0,0,0,0.15)'
//                     }
//                   }}
//                   onClick={() => handlePlanSelect(plan)}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                     <Radio 
//                       checked={selectedPlan?.plan_id === plan.plan_id}
//                       color="primary"
//                       size="small"
//                     />
//                     <Typography variant="subtitle1">{plan.displayName}</Typography>
//                   </Box>
//                  <Typography 
//   variant="h6" 
//   color="primary" 
//   gutterBottom
//   sx={{ textAlign: 'center' }}
// >
//   {plan.actual_price && plan.actual_price !== plan.charges ? (
//     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
//       <Typography 
//         component="span" 
//         sx={{ 
//           textDecoration: 'line-through',
//           color: 'text.secondary',
//           fontSize: '0.9rem'
//         }}
//       >
//         ₹{plan.actual_price}
//       </Typography>
//       <Typography component="span"
//        sx={{ 
//           color: 'primary',
//           fontSize: '1.2rem'
//         }}
//         >
//         ₹{plan.charges}
//       </Typography>
//     </Box>
//   ) : (
//     `₹${plan.charges}`
//   )}
// </Typography>
//                  <ul style={{ 
//   paddingLeft: '20px', 
//   margin: 0,
//   fontSize: '0.9rem',
//   listStyleType: 'none'
// }}>
//   {userTypeMappings[selectedUserType].features.map(feature => {
//     const unlimitedKey = `${feature}_unlimited`;
//     const isUnlimited = plan[unlimitedKey];
//     const value = isUnlimited ? 'unlimited' : plan[feature];
    
//     let displayText = '';
    
//     if (feature === 'no_of_properties') {
//       if (selectedUserType === 'buyer' || selectedUserType === 'tenant') {
//         displayText = isUnlimited 
//           ? 'You can access unlimited owner details'
//           : `You can access owner details- ${value}`;
//       } else {
//         displayText = isUnlimited 
//           ? 'You can add unlimited properties'
//           : `You can add properties- ${value} `;
//       }
//     } else if (feature === 'no_of_liked_data') {
//       displayText = isUnlimited 
//         ? 'You can access unlimited wishlist details'
//         : `You can access wishlist details- ${value} `;
//     } else if (feature === 'matching_enquiry') {
//       displayText = isUnlimited 
//         ? 'You can access unlimited Buyer details'
//         : `You can access Buyer details - ${value} `;
//     }
    
//     return (
//       <li key={feature} style={{ marginBottom: '4px' }}>
//         • {displayText}
//       </li>
//     );
//   })}
//    <li style={{ marginBottom: '4px' }}>• You can boost up your properties</li>
//   <li style={{ marginBottom: '4px' }}>• Daily Wishlist Tracking</li>
// </ul>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Card>
//       )}

//       {/* Payment Section */}
//       {selectedPlan && (
//         <Card 
//         ref={paymentRef}
//         sx={{
//           borderRadius: '12px',
//           boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//           background: 'rgba(255, 255, 255, 0.8)',
//           p: 2
//         }}>
//           <Typography variant="h5" gutterBottom sx={{ fontSize: '1.3rem' }}>Payment Details</Typography>
//           <Divider sx={{ mb: 2 }} />
          
//           <Box component="form" onSubmit={handlePaymentSubmit}>
//             <Typography variant="h6" gutterBottom>Selected Plan:</Typography>
//             <Table size="small">
//               <TableBody>
//                 <TableRow>
//                   <TableCell sx={{ padding: '6px' }}>Plan Type</TableCell>
//                   <TableCell sx={{ padding: '8px' }}>{selectedPlan.plan_name}</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell sx={{ padding: '8px' }}>User Type</TableCell>
//                   <TableCell sx={{ padding: '8px' }}>{selectedPlan.user_type}</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell sx={{ padding: '8px' }}>Price</TableCell>
//                   <TableCell sx={{ padding: '8px' }}>₹{selectedPlan.charges}</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>

//             <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
//               <Button 
//                 type="submit" 
//                 variant="contained" 
//                 size="medium"
//                 disabled={!selectedPlan}
//                 fullWidth
//                 sx={{
//                   borderRadius: '8px',
//                   py: 1,
//                   fontWeight: 600
//                 }}
//               >
//                 Complete Payment
//               </Button>
//             </Box>
//           </Box>
//         </Card>
//       )}
//     </Container>
//   );
// };

// export default SubscriptionForm;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  Grid,
  Divider,
  Button,
  Table,
  TableBody,
  TableCell,
  Container,
  TableRow,
  FormControlLabel,
  Checkbox,
  Radio,
  Tabs,
  Tab,
  Alert
} from '@mui/material';
import Chip from '@mui/material/Chip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

// Mapping between user types and plan features
const userTypeMappings = {
  // buyer: {
  //   label: 'Buyer',
  //   features: ['no_of_properties']
  // },
  seller: {
    label: 'Individual Owner/Builder',
    features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
  },
  agent: {
    label: 'Agent',
    features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
  },
  // tenant: {
  //   label: 'Tenant',
  //   features: ['no_of_properties']
  // },
  landlord: {
    label: 'Landlord',
    features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
  }
};

const PlanCard = ({ 
  plan, 
  isSelected, 
  onSelect, 
  userType, 
  isAddon = false 
}) => {
  const mapping = userTypeMappings[userType] || {};
  
  return (
    <Card 
      sx={{ 
        p: 2,
        width: '100%',
        minWidth: { xs: '260px', sm: '280px' },
        maxWidth: { xs: '300px', sm: '320px' },
        border: isSelected ? '2px solid #1976d2' : '1px solid rgba(0, 0, 0, 0.08)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(247,249,252,0.95) 100%)',
        borderRadius: '12px',
        boxShadow: isSelected ? '0 8px 32px rgba(25, 118, 210, 0.2)' : '0 4px 24px rgba(0,0,0,0.05)',
        '&:hover': {
          transform: { xs: 'none', sm: 'translateY(-4px)' },
          boxShadow: { xs: '0 4px 16px rgba(0,0,0,0.1)', sm: '0 8px 32px rgba(0,0,0,0.15)' }
        },
        position: 'relative',
        overflow: 'hidden',
        '::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: isAddon 
            ? 'linear-gradient(90deg, #ff9800 0%, #ffc46b 100%)' 
            : 'linear-gradient(90deg, #1976d2 0%, #4dabf5 100%)'
        }
      }}
      onClick={onSelect}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Radio 
            checked={isSelected}
            color={isAddon ? 'warning' : 'primary'}
            size="small"
            sx={{ 
              color: isSelected ? (isAddon ? '#ff9800' : '#1976d2') : '#ccc',
              '&.Mui-checked': {
                color: isAddon ? '#ff9800' : '#1976d2'
              }
            }}
          />
          <Typography variant="subtitle1" sx={{ 
            fontWeight: '600',
            color: '#2a3f5f',
            fontSize: { xs: '1rem', sm: '1.05rem' }
          }}>
            {isAddon ? 'Addon: ' : ''}{plan.plan_name || 'Addon Plan'}
          </Typography>
        </Box>
        {plan.isPopular && (
          <Chip 
            label="Popular" 
            size="small" 
            sx={{ 
              backgroundColor: '#ffeb3b',
              color: '#2a3f5f',
              fontWeight: 'bold',
              fontSize: '0.7rem',
              height: '20px'
            }} 
          />
        )}
      </Box>

      <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', mt: 1, mb: 2 }}>
        {plan.actual_price && plan.actual_price !== plan.charges ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
            <Typography component="span"
              sx={{ 
                color: isAddon ? '#ff9800' : '#1976d2',
                fontSize: { xs: '1.6rem', sm: '1.7rem' },
                fontWeight: '700'
              }}
            >
              ₹{plan.charges}
            </Typography>
            <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography 
                component="span" 
                sx={{ 
                  textDecoration: 'line-through',
                  color: 'text.secondary',
                  fontSize: { xs: '1.0rem', sm: '0.9rem' }
                }}
              >
                ₹{plan.actual_price}
              </Typography>
              <Chip 
                label={`${Math.round((1 - plan.charges/plan.actual_price)*100)}% OFF`} 
                size="small" 
                sx={{ 
                  backgroundColor: '#4caf50',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '0.7rem',
                  height: '20px'
                }} 
              />
            </Box>
          </Box>
        ) : (
          <Typography
            sx={{ 
              color: isAddon ? '#ff9800' : '#1976d2',
              fontSize: { xs: '1.6rem', sm: '1.7rem' },
              fontWeight: '700'
            }}
          >
            ₹{plan.charges}
          </Typography>
        )}
      </Typography>

      <Divider sx={{ my: 1, borderColor: 'rgba(0, 0, 0, 0.08)' }} />

      <ul style={{ 
        paddingLeft: '20px', 
        margin: 0,
        fontSize: { xs: '0.85rem', sm: '0.9rem' },
        listStyleType: 'none'
      }}>
        {mapping.features?.map(feature => {
          const unlimitedKey = `${feature}_unlimited`;
          const isUnlimited = plan[unlimitedKey];
          const value = isUnlimited ? 'unlimited' : plan[feature];
          
          let displayText = '';
          
          if (feature === 'no_of_properties') {
            if (userType === 'buyer' || userType === 'tenant') {
              displayText = isUnlimited 
                ? 'Unlimited owner details access'
                : `Access owner details: ${value}`;
            } else {
              displayText = isUnlimited 
                ? 'List an unlimited number of properties'
                : `List properties limit: ${value}`;
            }
          } else if (feature === 'no_of_liked_data') {
            displayText = isUnlimited 
              ? 'Access wishlist without limitations'
              : `Wishlist access limit: ${value}`;
          } else if (feature === 'matching_enquiry') {
            displayText = isUnlimited 
              ? 'View unlimited buyer inquiries'
              : `Buyer inquiries access limit: ${value}`;
          }
          
          return (
            <li key={feature} style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon 
                sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} 
              />
              <span>{displayText}</span>
            </li>
          );
        })}
        
        {['buyer', 'tenant'].includes(userType) ? (
          <>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} />
              <span>You can wishlist any properties</span>
            </li>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} />
              <span>Communicate via chat with property owners</span>
            </li>
          </>
        ) : (
          <>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} />
              <span>Property boost feature</span>
            </li>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} />
              <span>Daily wishlist tracking</span>
            </li>
          </>
        )}
      </ul>

      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Button
          variant="contained"
          size="small"
          sx={{
            background: isAddon 
              ? 'linear-gradient(90deg, #ff9800 0%, #ffb74d 100%)' 
              : 'linear-gradient(90deg, #1976d2 0%, #4dabf5 100%)',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: { xs: '0.8rem', sm: '0.85rem' },
            padding: { xs: '6px 12px', sm: '8px 16px' },
            boxShadow: isAddon 
              ? '0 2px 8px rgba(255, 152, 0, 0.3)' 
              : '0 2px 8px rgba(25, 118, 210, 0.3)',
            '&:hover': {
              background: isAddon 
                ? 'linear-gradient(90deg, #f57c00 0%, #ffa726 100%)' 
                : 'linear-gradient(90deg, #1565c0 0%, #42a5f5 100%)',
              boxShadow: isAddon 
                ? '0 4px 12px rgba(255, 152, 0, 0.4)' 
                : '0 4px 12px rgba(25, 118, 210, 0.4)'
            }
          }}
        >
          {isAddon ? 'Select Addon' : 'Select Plan'}
        </Button>
      </Box>
    </Card>
  );
};

const SubscriptionForm = ({ 
  selectedUserType, 
  setSelectedUserType, 
  selectedPlan, 
  setSelectedPlan,
  selectedAddon,
  setSelectedAddon,
  plans, 
  handlePaymentSubmit,
  subscriptions = [] // Default to empty array if not provided
}) => {

  const [activeTab, setActiveTab] = useState(0);
  const alertRef = React.useRef(null);
   const [addonPlans, setAddonPlans] = useState([]);
  const [loadingAddons, setLoadingAddons] = useState(false);
  const paymentRef = React.useRef(null);
   const [clickedPlan, setClickedPlan] = useState(null); // Track clicked plan for alert
  
  // Check if user has active main plan for selected user type
  const hasActiveMainPlan = subscriptions.some(
    sub => sub.user_type === userTypeMappings[selectedUserType]?.label && sub.status === true
  );

  // Check for existing subscription conflict (only for main plans)
  const hasExistingSubscription = activeTab === 0 && clickedPlan 
  ? subscriptions.some(
      sub => sub.user_type === clickedPlan.user_type && 
             sub.status === true && 
             (clickedPlan.plan_name === "Free" || sub.plan_name !== "Free")
    )
  : false;

  // Auto-scroll to alert when it appears
  useEffect(() => {
    if (hasExistingSubscription && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [hasExistingSubscription]);

  // Determine if we should show payment section
  const showPaymentSection = (
    (selectedAddon && !loadingAddons) || 
    (selectedPlan && activeTab === 0 && !hasExistingSubscription)
  );

  // Filter addon plans - only show if user has active main plan
  const filteredAddonPlans = hasActiveMainPlan ? addonPlans : [];

  
  const handleUserTypeChange = (userType) => {
    setSelectedUserType(userType);
    setSelectedPlan(null);
    setSelectedAddon(null);
    setActiveTab(0);
  };

const handlePlanSelect = (plan) => {
  if (activeTab === 0) {
    setClickedPlan(plan);
    
    // Check for conflict only if:
    // 1. Selected plan is Free and user has any active plan
    // OR
    // 2. Selected plan is paid and user has active paid plan
    const hasConflict = subscriptions.some(
      sub => sub.user_type === plan.user_type && 
             sub.status === true && 
             (plan.plan_name === "Free" || sub.plan_name !== "Free")
    );

    if (hasConflict) {
      setSelectedPlan(null);
      setSelectedAddon(null);
    } else {
      setSelectedPlan(plan);
      setSelectedAddon(null);
    }
  } else {
    setSelectedAddon(plan);
  }

  setTimeout(() => {
    paymentRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, 100);
};

  // Get relevant plans for the selected user type
  const getFilteredPlans = () => {
    if (!selectedUserType) return [];
    const userTypeLabel = userTypeMappings[selectedUserType].label;
    return plans
      .filter(plan => plan.user_type === userTypeLabel && plan.status === true)
      .map(plan => ({
        ...plan,
        displayName: `${plan.plan_name} ${userTypeLabel} Plan`
      }));
  };

  // Fetch addon plans when user type changes
  useEffect(() => {
    if (!selectedUserType) return;
    
    const fetchAddonPlans = async () => {
      setLoadingAddons(true);
      try {
        const response = await fetch('https://landnest.net:81/add-on/');
        const data = await response.json();
        const userTypeLabel = userTypeMappings[selectedUserType].label;
        const filteredAddons = data.filter(addon => 
          addon.user_type === userTypeLabel && addon.status === true
        );
        setAddonPlans(filteredAddons);
      } catch (error) {
        console.error('Error fetching addon plans:', error);
        setAddonPlans([]);
      } finally {
        setLoadingAddons(false);
      }
    };
    
    fetchAddonPlans();
  }, [selectedUserType]);

  return (
    <Container sx={{ py: 4, flex: 1, display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 'sm' }}>
      <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', mt: 0 }}>Choose Your Subscription</Typography>
      
      {/* User Type Selection */}
      <Card sx={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', p: 2 }}>
        <Typography variant="h6" gutterBottom>I am a:</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {Object.keys(userTypeMappings).map((userType) => (
            <FormControlLabel
              key={userType}
              control={
                <Checkbox
                  checked={selectedUserType === userType}
                  onChange={() => handleUserTypeChange(userType)}
                  color="primary"
                  size="small"
                />
              }
              label={<Typography variant="body2">{userTypeMappings[userType].label}</Typography>}
              sx={{ margin: 0 }}
            />
          ))}
        </Box>
      </Card>

      {/* Plan Selection */}
        {selectedUserType && (
      <Card sx={{
        borderRadius: '16px',
        boxShadow: '0 4px 30px rgba(0,0,0,0.08)',
        p: 2,
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <Typography variant="h6" gutterBottom sx={{ 
          textAlign: 'center',
          fontWeight: '600',
          color: '#2a3f5f',
          fontSize: { xs: '1.1rem', sm: '1.25rem' }
        }}>
          Available {userTypeMappings[selectedUserType].label} Plans:
        </Typography>
        
        <Tabs 
          value={activeTab} 
           onChange={(e, newValue) => {
              setActiveTab(newValue);
              setClickedPlan(null); // Reset clicked plan when switching tabs
            }}
          sx={{ mb: 2 }}
          centered
        >
          <Tab label="Main Plans" />
          <Tab label="Addon Plans" />
        </Tabs>
        
        <Box sx={{ pt: 1 }}>
          {activeTab === 0 ? (
            <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
  {getFilteredPlans()
    .filter(plan => plan.plan_name !== "Free") // Add this filter to exclude Free plans
    .map((plan) => (
      <Grid item xs={12} sm={6} md={4} key={plan.plan_id}>
        <PlanCard 
          plan={plan} 
          isSelected={selectedPlan?.plan_id === plan.plan_id}
          onSelect={() => handlePlanSelect(plan)}
          userType={selectedUserType}
        />
      </Grid>
    ))}
</Grid>
          ) : (
            <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
              {loadingAddons ? (
                <Typography>Loading addon plans...</Typography>
              ) : !hasActiveMainPlan ? (
                <Alert severity="info" sx={{ width: '100%', my: 2 }}>
                  You need an active {userTypeMappings[selectedUserType]?.label} plan to purchase addons
                </Alert>
              ) : filteredAddonPlans.length > 0 ? (
                filteredAddonPlans.map((plan) => (
                  <Grid item xs={12} sm={6} md={4} key={plan.addOn_id}>
                    <PlanCard 
                      plan={plan} 
                      isSelected={selectedAddon?.addOn_id === plan.addOn_id}
                      onSelect={() => handlePlanSelect(plan)}
                      userType={selectedUserType}
                      isAddon
                    />
                  </Grid>
                ))
              ) : (
                <Typography>No addon plans available for this user type</Typography>
              )}
            </Grid>
          )}
        </Box>
      </Card>
    )}

      {/* Warning for existing subscription */}
    {activeTab === 0 && hasExistingSubscription && (
        <Alert 
          severity="warning" 
          sx={{ mt: 2, mb: 2 }}
          ref={alertRef}
        >
          You already have an Active {clickedPlan?.user_type} Subscription.
          To get More Features you can Purchase AddOn Plans.
        </Alert>
      )}

     {showPaymentSection && (
        <Card 
          ref={paymentRef}
          sx={{
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            p: 2,
            mb: 3
          }}
        >
          <Typography variant="h5" gutterBottom sx={{ fontSize: '1.3rem' }}>
            Payment Details
          </Typography>
          <Divider sx={{ mb: 2 }} />
          
          <Box component="form" onSubmit={handlePaymentSubmit}>
            <Typography variant="h6" gutterBottom>
              Selected {selectedAddon ? 'Addon' : 'Plan'}:
            </Typography>
            
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell sx={{ padding: '6px' }}>Type</TableCell>
                  <TableCell sx={{ padding: '8px' }}>
                    {selectedAddon ? 'Addon Plan' : selectedPlan?.plan_name}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: '8px' }}>User Type</TableCell>
                  <TableCell sx={{ padding: '8px' }}>
                    {selectedAddon ? selectedAddon.user_type : selectedPlan?.user_type}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: '8px' }}>Price</TableCell>
                  <TableCell sx={{ padding: '8px' }}>
                    ₹{selectedAddon ? selectedAddon.charges : selectedPlan?.charges}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>

           <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Button 
                type="submit" 
                variant="contained" 
                size="medium"
                fullWidth
                sx={{
                  borderRadius: '8px',
                  py: 1,
                  fontWeight: 600
                }}
              >
                Complete Payment
              </Button>
            </Box>
          </Box>
        </Card>
      )}
    </Container>
  );
};

export default SubscriptionForm;